import {
  ESTIMATED_VALUE_DEFAULT,
  DOWN_PAYMENT_DEFAULT,
  LOAN_AMOUNT_DEFAULT,
  PURCHASE_TYPE,
  REFINANCE_TYPE,
} from 'mortgage-combined/rate-table/widget/common/constants'
import { SET_SUBMISSION_TYPE } from '../types'

const initialState = {
  [PURCHASE_TYPE]: {
    downPayment: DOWN_PAYMENT_DEFAULT,
    estimatedValue: ESTIMATED_VALUE_DEFAULT,
  },
  [REFINANCE_TYPE]: {
    loanAmount: LOAN_AMOUNT_DEFAULT,
  },
}

export default (state = initialState, { type, payload }) => {
  const { submission, vertical } = payload || {}

  switch (type) {
    case SET_SUBMISSION_TYPE:
      return {
        ...state,
        [vertical]: submission,
      }

    default:
      return state
  }
}
